/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CBasketStatus {
    SENT = 'Sent',
    SOLD = 'Sold',
    CANCELLED = 'Cancelled',
}
